"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Conditions = _interopRequireDefault(require("access-control-lib/conditions/Conditions"));

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var _selectors = require("settings-ui-sdk/Auth/selectors");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _default = function _default(loadingActions, loadingRequestStatusSelectors) {
  var optionalAccessControl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var unrecoverableFailure = arguments.length > 3 ? arguments[3] : undefined;
  var successMarker = arguments.length > 4 ? arguments[4] : undefined;
  var failureMarker = arguments.length > 5 ? arguments[5] : undefined;
  return function (Component) {
    var actions = loadingActions;

    if (typeof loadingActions === 'function') {
      actions = [loadingActions];
    }

    var selectors = loadingRequestStatusSelectors;

    if (typeof loadingRequestStatusSelectors === 'function') {
      selectors = [loadingRequestStatusSelectors];
    }

    var LoadOnMountHOCWrapper =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inherits2.default)(LoadOnMountHOCWrapper, _PureComponent);

      function LoadOnMountHOCWrapper() {
        (0, _classCallCheck2.default)(this, LoadOnMountHOCWrapper);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LoadOnMountHOCWrapper).apply(this, arguments));
      }

      (0, _createClass2.default)(LoadOnMountHOCWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this.props.permitted) {
            this.props.loaders.forEach(function (loader) {
              return loader();
            });
          }
        }
      }, {
        key: "render",
        value: function render() {
          /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/

          /*eslint react/prop-types: [2, { "ignore": ["dispatch"]}]*/
          var _this$props = this.props,
              dispatch = _this$props.dispatch,
              loaders = _this$props.loaders,
              permitted = _this$props.permitted,
              requestStatuses = _this$props.requestStatuses,
              rest = (0, _objectWithoutProperties2.default)(_this$props, ["dispatch", "loaders", "permitted", "requestStatuses"]);

          var wrapped = _react.default.createElement(Component, rest);

          if (permitted) {
            return _react.default.createElement(_LoadingHOC.default, {
              requestStatuses: requestStatuses,
              unrecoverableFailure: unrecoverableFailure,
              successMarker: successMarker,
              failureMarker: failureMarker
            }, wrapped);
          } else {
            return wrapped;
          }
        }
      }]);
      return LoadOnMountHOCWrapper;
    }(_react.PureComponent);

    LoadOnMountHOCWrapper.propTypes = {
      loaders: _react.PropTypes.arrayOf(_react.PropTypes.func).isRequired,
      permitted: _react.PropTypes.bool.isRequired,
      requestStatuses: _react.PropTypes.arrayOf(_RequestStatusTypes.RequestStatusPropType).isRequired
    };

    var mapStateToProps = function mapStateToProps(state) {
      var gates = (0, _selectors.getUserGates)(state);
      var scopes = (0, _selectors.getUserScopes)(state);
      return {
        permitted: !optionalAccessControl || _Conditions.default.shouldAccess(optionalAccessControl)({
          gates: gates,
          scopes: scopes
        }),
        requestStatuses: selectors.map(function (selector) {
          return selector(state);
        })
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return {
        loaders: actions.map(function (action) {
          return function () {
            return dispatch(action());
          };
        })
      };
    };

    var name = Component.displayName || Component.name;
    LoadOnMountHOCWrapper.displayName = "LoadOnMount(" + name + ")";
    LoadOnMountHOCWrapper.wrappedComponent = Component;
    return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoadOnMountHOCWrapper);
  };
};

exports.default = _default;
module.exports = exports.default;